var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSolar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.1899 79.6899H19.95L29.95 31.85H71.1899L81.1899 79.6899Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1899 79.6899V77.6899H22.4099L31.5699 33.85H69.5599L79.2299 80.1L81.1899 79.6899V77.6899V79.6899L83.1499 79.28L73.1499 31.4399C72.9599 30.5099 72.1399 29.85 71.1899 29.85H29.9499C28.9999 29.85 28.1899 30.5099 27.9899 31.4399L17.9899 79.28C17.8699 79.87 18.0199 80.4799 18.3999 80.95C18.7799 81.42 19.3499 81.6899 19.9499 81.6899H81.1899C81.7899 81.6899 82.3599 81.42 82.7399 80.95C83.1199 80.4799 83.2699 79.87 83.1499 79.28L81.1899 79.6899Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 31.79L37.5 79.4301L41.48 79.76L45.48 32.12",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6699 32.12L59.6699 79.76L63.65 79.4301L59.65 31.79",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.06 62.2H22.72V66.2H78.06",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0399 44.24H26.9399V48.24H74.0399",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.18 88.49V86.49H44.97V81.6899H56.18V88.49H58.18V86.49V88.49H60.18V79.6899C60.18 79.1599 59.97 78.65 59.59 78.28C59.22 77.91 58.7 77.6899 58.18 77.6899H42.97C42.44 77.6899 41.93 77.9 41.56 78.28C41.19 78.65 40.97 79.1699 40.97 79.6899V88.49C40.97 89.02 41.18 89.53 41.56 89.9C41.93 90.27 42.45 90.49 42.97 90.49H58.18C58.71 90.49 59.22 90.28 59.59 89.9C59.96 89.53 60.18 89.01 60.18 88.49H58.18Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.65 86.49H36.5C35.4 86.49 34.5 87.39 34.5 88.49C34.5 89.59 35.4 90.49 36.5 90.49H64.65C65.75 90.49 66.65 89.59 66.65 88.49C66.65 87.39 65.75 86.49 64.65 86.49Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.19 16.26H86.19C86.19 17.34 85.75 18.31 85.04 19.03C84.33 19.74 83.36 20.1801 82.27 20.1801C81.19 20.1801 80.22 19.74 79.5 19.03C78.79 18.32 78.35 17.35 78.35 16.26C78.35 15.18 78.79 14.21 79.5 13.49C80.21 12.78 81.18 12.34 82.27 12.34C83.35 12.34 84.32 12.78 85.04 13.49C85.75 14.2 86.19 15.17 86.19 16.26H87.19H88.19C88.19 13 85.54 10.35 82.28 10.35C79.01 10.35 76.37 13 76.37 16.26C76.37 19.53 79.02 22.17 82.28 22.17C85.55 22.17 88.19 19.52 88.19 16.26H87.19Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M81.28 5.21997V8.02002C81.28 8.57002 81.73 9.02002 82.28 9.02002C82.83 9.02002 83.28 8.57002 83.28 8.02002V5.21997C83.28 4.66997 82.83 4.21997 82.28 4.21997C81.73 4.21997 81.28 4.66997 81.28 5.21997Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M81.28 24.5V27.3C81.28 27.85 81.73 28.3 82.28 28.3C82.83 28.3 83.28 27.85 83.28 27.3V24.5C83.28 23.95 82.83 23.5 82.28 23.5C81.73 23.5 81.28 23.94 81.28 24.5Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.37 7.74001L87.39 9.71999C87 10.11 87 10.74 87.39 11.13C87.78 11.52 88.41 11.52 88.8 11.13L90.78 9.15004C91.17 8.76004 91.17 8.13001 90.78 7.74001C90.4 7.35001 89.76 7.35001 89.37 7.74001Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.74 21.37L73.76 23.35C73.37 23.74 73.37 24.37 73.76 24.76C74.15 25.15 74.78 25.15 75.17 24.76L77.15 22.78C77.54 22.39 77.54 21.76 77.15 21.37C76.77 20.98 76.13 20.98 75.74 21.37Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.31 15.26H90.51C89.96 15.26 89.51 15.71 89.51 16.26C89.51 16.81 89.96 17.26 90.51 17.26H93.31C93.86 17.26 94.31 16.81 94.31 16.26C94.31 15.71 93.87 15.26 93.31 15.26Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.04 15.26H71.24C70.69 15.26 70.24 15.71 70.24 16.26C70.24 16.81 70.69 17.26 71.24 17.26H74.04C74.59 17.26 75.04 16.81 75.04 16.26C75.04 15.71 74.59 15.26 74.04 15.26Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.79 23.35L88.81 21.37C88.42 20.98 87.79 20.98 87.4 21.37C87.01 21.76 87.01 22.39 87.4 22.78L89.38 24.76C89.77 25.15 90.4 25.15 90.79 24.76C91.18 24.38 91.18 23.74 90.79 23.35Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.16 9.71999L75.18 7.74001C74.79 7.35001 74.16 7.35001 73.77 7.74001C73.38 8.13001 73.38 8.76004 73.77 9.15004L75.75 11.13C76.14 11.52 76.77 11.52 77.16 11.13C77.55 10.74 77.55 10.11 77.16 9.71999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolar);
export default __webpack_public_path__ + "static/media/icon_solar.bc4ab4d77fcdd5ddb47f4570b8a2f65e.svg";
export { ForwardRef as ReactComponent };